module.exports = "/assets/a3caacb3409274addcf68c8f40039fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9K.png
// module id = 1163
// module chunks = 0